import { useQuery } from '@tanstack/react-query';
import outputs from 'root/cfOutput';
import { GET_ALERTS_URL } from 'root/src/shared/descriptions/endpoints/endpointIds';
import { dareDropClient } from 'root/src/client/v2/common/clients/dareDropClient';
import { globalQueryClient } from 'root/src/client/v2/common/clients/queryClient';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { CopyField } from 'root/src/client/v2/common/components/ui/copy-field';
import { Skeleton } from 'root/src/client/v2/common/components/ui/skeleton';
import { OBSAlertsSection } from './OBSAlertsSection';
import { OBSTopDaresSection } from './OBSTopDaresSection';
const { domainName } = outputs;
export const OBSPanel = () => {
    const { authentication } = useAuthentication();
    const tokenQuery = useQuery({
        queryKey: [GET_ALERTS_URL],
        queryFn: () => dareDropClient({ endpointId: GET_ALERTS_URL }),
        enabled: !!authentication,
    }, globalQueryClient);
    const token = tokenQuery.data;
    const audioUrl = token ? `https://obs.${domainName}/${token}` : '';
    const topDaresUrl = token ? `https://obs.${domainName}/topDares/${token}` : '';
    return (<div className="space-y-6">
			<div>
				<h3 className="mb-1 text-sm font-semibold">OBS Integrations</h3>
				<p className="mb-4 text-xs text-muted-foreground">
					Add these as Browser Source layers in OBS to show dare alerts and the top dares overlay on your stream.
				</p>
				{tokenQuery.isLoading ? (<div className="space-y-4">
						<Skeleton className="h-9 w-full"/>
						<Skeleton className="h-9 w-full"/>
					</div>) : (<div className="space-y-4">
						<CopyField label="Audio Alerts (Browser Source)" value={audioUrl}/>
						<CopyField label="Top Dares overlay (Browser Source)" value={topDaresUrl}/>
					</div>)}
			</div>
			<div className="rounded-xl border border-solid border-border/30 bg-secondary/10 p-3">
				<p className="text-[11px] leading-relaxed text-muted-foreground">
					<span className="font-medium text-foreground">How to add:</span>{' '}
					In OBS add a new Browser Source, paste the URL, and size it to your canvas. Alerts play when viewers complete your dares.
				</p>
			</div>
			<div className="border-t border-solid border-white/[0.06] pt-6">
				<OBSAlertsSection />
			</div>
			<div className="border-t border-solid border-white/[0.06] pt-6">
				<OBSTopDaresSection />
			</div>
		</div>);
};
